import request from 'utils/request';
import { USER_URL } from 'constants/api';

/**
 * fetches current user info
 * @returns { Promise }
 */
export const getCurrentUser = () => request.get(`${USER_URL}/me`);
